module.exports = __webpack_public_path__ + "img/SportsInformation.563ee106.svg";